"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Bonus_vue_1 = require("@/client/components/Bonus.vue");
const BoardSpaceTile_vue_1 = require("@/client/components/board/BoardSpaceTile.vue");
const UndergroundResources_vue_1 = require("@/client/components/board/UndergroundResources.vue");
const PreferencesManager_1 = require("../utils/PreferencesManager");
exports.default = vue_1.default.extend({
    name: 'board-space',
    props: {
        space: {
            type: Object,
        },
        text: {
            type: String,
        },
        aresExtension: {
            type: Boolean,
        },
        tileView: {
            type: String,
        },
    },
    data() {
        return {};
    },
    components: {
        'bonus': Bonus_vue_1.default,
        'board-space-tile': BoardSpaceTile_vue_1.default,
        'underground-resources': UndergroundResources_vue_1.default,
    },
    methods: {
        getMainClass() {
            let css = 'board-space board-space-' + this.space?.id.toString();
            css += ' board-space-selectable';
            return css;
        },
    },
    computed: {
        showBonus() {
            return this.space?.tileType === undefined || this.tileView === 'hide';
        },
        playerColorCss() {
            if (this.space?.color === undefined) {
                return '';
            }
            const css = 'board-cube board-cube--' + this.space.color;
            return (0, PreferencesManager_1.getPreferences)().symbol_overlay ? css + ' overlay' : css;
        },
    },
});
